

<div style="display: inline;">
    <button  mat-raised-button (click)="open()"  class="btncss" >{{menuData.categoryName | characterPipe}}
    </button>
</div>